<template>
    <section class="sub_page_con wrap_1120">
        <div class="total_num">
            <span>Total</span>
            <span class="total_num_value">{{ state.totalLength }}</span>
        </div>
        <div class="btn_wrap _default right_btn _board_type" v-if="state.hasAuth">
            <button type="button" class="common_btn _gray" @click="isDelete">삭제</button>
            <router-link class="common_btn w_130" :to="{ name: 'NewsWrite' }">글쓰기</router-link>
        </div>
        <div class="con_card sub_page_con_view">
            <!-- TODO :: yn -->
            <ul>
                <li class="checkbox_wrap" v-for="item in state.list" :key="item.idx" v-if="state.list.length > 0">
                    <template v-if="!state.isMobile">
                        <label :for="item.idx + ''" class="card_tag">
                            <template v-if="state.hasAuth">
                                <input type="checkbox" name="chk" :id="item.idx + ''" @click="selectedIdx(item.idx)" />
                                <em></em>
                            </template>
                        </label>
                        <router-link :to="{ name: 'NewsView', params: { id: item.idx } }">
                            <div class="img_wrap">
                                <img v-if="item.thumbnail" :src="item.thumbnail" alt="" />
                                <img v-else src="img/no_img1.png" alt="" />
                            </div>
                            <div class="tit_wrap">
                                <div class="elips_2">
                                    {{ item.title }}
                                </div>
                                <div class="tit_date">{{ CommonUtils.dateFormat(new Date(item.createDate), ".", true) }}</div>
                            </div>
                        </router-link>
                    </template>

                    <template v-else>
                        <label :for="item.idx + ''" class="card_tag">
                            <template v-if="state.hasAuth">
                                <input type="checkbox" name="chk" :id="item.idx + ''" @click="selectedIdx(item.idx)" />
                                <em></em>
                            </template>
                        </label>
                        <router-link :to="{ name: 'NewsView', params: { id: item.idx } }">
                            <div class="img_wrap">
                                <img v-if="item.thumbnail" :src="item.thumbnail" alt="" />
                            </div>
                            <div class="tit_wrap">
                                <div class="elips_2">
                                    {{ item.title }}
                                </div>
                                <div class="tit_date">{{ CommonUtils.dateFormatForMobile(new Date(item.createDate), ".", true) }}</div>
                            </div>
                        </router-link>
                    </template>
                </li>
                <li v-else class="tbody_li no_data">
                    <div class="tr_div">
                        <div class="tb_subject" style="text-align: center; width: 100%">등록된 게시물이 없습니다.</div>
                    </div>
                </li>
            </ul>
        </div>
        <PageBtn
            v-if="state.list.length !== 0"
            :currentPage="state.page"
            :totalLength="state.totalLength"
            :perPage="state.size"
            @onPaging="handlePageChange"
        ></PageBtn>
    </section>
    <ModalDefault
        v-if="state.isShowModal"
        :type="state.modalTab"
        :title="state.modalTitle"
        :content="state.modalContent"
        @close="closeModal"
        @callback="callBackModal"
    ></ModalDefault>
</template>
<script lang="ts" config>
    import {
        reactive,
        globalStore,
        onMounted,
        watch,
        router,
        apiService,
        types,
        CommonUtils,
        PageBtn,
        onBeforeMount,
        userStore,
        ModalDefault,
        getMessageByCode,
    } from "@/BaseComponent";

    export default {
        components: { PageBtn, ModalDefault },
        setup() {
            const global = globalStore();
            const user = userStore();
            const state = reactive({
                tab: 0 as number,

                page: 1 as number,
                size: 6 as number,
                totalPage: 1 as number,
                totalLength: 0 as number,

                list: [] as Array<types.ResBoardVOForApi>,

                searchType: "" as string,
                searchText: "" as string,

                isShowModal: false as boolean,
                modalTab: -1 as number,
                modalIsResult: false as boolean,
                modalTitle: "alert" as string,
                modalContent: "" as string,

                hasAuth: false,

                idxList: [] as Array<number>,

                isMobile: false,
            });

            onBeforeMount(() => {
                if (
                    user.isLogin() &&
                    (user.userInfo.gubun === 1 ||
                        (user.userInfo.isAdmin && user.roles != null && user.roles.some((item: types.RoleVO) => item.key.indexOf("news") > -1)))
                )
                    state.hasAuth = true;
            });

            onMounted(() => {
                getList();

                state.isMobile = window.innerWidth < 768;
            });

            const getList = async () => {
                const param: types.ReqCommonPaging = {
                    page: state.page,
                    size: state.size,
                    searchType: null,
                    searchText: state.searchText,
                };
                const res = await apiService.boardNews.list(param);
                if (res.returnCode === 0) {
                    state.list = res.list.data;
                    state.totalPage = res.list.totalPages;
                    state.totalLength = res.list.recordsTotal;
                } else if (res.returnCode === 11) {
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "예외 발생";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                    state.list = [];
                    state.totalPage = 0;
                    state.totalLength = 0;
                }
            };
            const getSearch = () => {
                state.page = 1;
                getList();
            };

            const handlePageChange = (page: number) => {
                state.page = page;
                getList();
            };

            const selectedIdx = (idx: number) => {
                if (state.idxList.indexOf(idx) > -1) state.idxList.splice(state.idxList.indexOf(idx), 1);
                else state.idxList.push(idx);
            };

            const closeModal = () => {
                state.isShowModal = false;
                getList();
            };

            const callBackModal = async (param: any) => {
                if (param.action === "confirm") {
                    remove();
                } else {
                    getList();
                }
            };

            const isDelete = () => {
                if (state.idxList.length === 0) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "선택된 게시글이 없습니다.";
                    state.isShowModal = true;
                } else {
                    state.modalTab = 5;
                    state.modalTitle = "알림";
                    state.modalContent = "정말 삭제하시겠습니까?";
                    state.isShowModal = true;
                }
            };

            const remove = async () => {
                if (state.idxList.length === 0) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "삭제하고자 하는 감시소식을 선택해주세요.";
                    state.isShowModal = true;
                } else {
                    const param: types.ReqIdxList = {
                        idxList: state.idxList.join(","),
                    };
                    const res = await apiService.boardNews.removeList(param);

                    if (res.returnCode === 0) {
                        state.modalTab = -1;
                        state.modalTitle = "알림";
                        state.modalContent = "삭제가 완료되었습니다.";
                        state.isShowModal = true;
                        state.idxList = [];

                        getList();
                    } else if (res.returnCode === 11) {
                    } else {
                        state.modalTab = -1;
                        state.modalTitle = "예외 발생";
                        state.modalContent = getMessageByCode(res.returnCode);
                        state.isShowModal = true;
                    }
                }
            };

            return { state, router, handlePageChange, CommonUtils, getSearch, isDelete, selectedIdx, closeModal, callBackModal };
        },
    };
</script>
